import educationImage from "../gallery/image10.jpg";
import legalAdvocacyImage from "../gallery/image40.jpg";
import healthcareImage from "../gallery/image42.jpg";
import sportsImage from "../gallery/image30.jpg";

export const programs = [
  {
    title: "Education for All",
    subtitle: "Tackling widespread illiteracy in Nomadic & Denotified Tribes",
    image:
      `url(${educationImage})`,
    description: "We have educated more than 1000 students with fully functional residential primary school, recognized and majority funded by Maharashtra State Government since 1999."
  },
  {
    title: "Legal Advocacy",
    subtitle: "Protecting the Rights of Nomadic & Denotified Tribes",
    image:
    `url(${legalAdvocacyImage})`,
    description:
    "We advocate for Nomadic & Denotified Tribes, ensuring their legal rights are protected and respected. Our work includes rehabilitation support, defending individuals against false criminal cases, and providing legal guidance. We actively collaborate with government agencies to correct gaps in welfare schemes, push for new inclusive programs, and educate officials about the economic and social realities of these communities."
  },
  {
    title: "Community Healthcare",
    subtitle: "Improving health and well-being in Nomadic & Denotified Tribes",
    image:
      `url(${healthcareImage})`,
    description: "We organize health camps, check-ups, and health awareness campaigns to provide special attention to women, children and the elderly."
  },
  {
    title: "Sports Training",
    subtitle: "Building Strength, Discipline & Teamwork",
    image:
      `url(${sportsImage})`,
    description:
      "We train students in boxing, wrestling, and cricket to build strength, discipline, and teamwork which will help them in opening pathways to competition and scholarships.",
  },
];
